$(function () {

    const body = $('body');

    headerInit();
    footerInit();
    customSelectInit();
    customFlagsInit();

    if (body.hasClass('type-category')) {
        categoryInit();
    }

    if (body.hasClass('type-detail')) {
        detailInit();
    }

    body.addClass('is-loaded');

});

// shoptet.custom.postSuccessfulValidation = function (form) {
//     // Najděte textarea uvnitř #note
//     const noteField = form.querySelector('#note #remark');
//
//     if (noteField) {
//         // Přidání nebo úprava hodnoty poznámky
//         noteField.value += ' Výšivka: xxx.';
//     }
//
//     console.log(form)
//
//     return false;
// };

function scrolling() {
}

function resizing() {
}

$(window).on("load", function () {
});

$(document).on('scroll', scrolling);
$(window).resize(resizing);